import type {
  BudgetConfig,
  DataResponse,
  GovernanceOverview,
  MySpendResponse,
  PlatformCostsResponse,
  UsageResponse,
  UserSpendResponse,
} from "@/types";
import { api } from "../api";

export const adminService = {
  getUsage: (params?: { start_date?: string; end_date?: string }) => {
    const searchParams = new URLSearchParams();
    if (params?.start_date) searchParams.set("start_date", params.start_date);
    if (params?.end_date) searchParams.set("end_date", params.end_date);
    return api.get<DataResponse<UsageResponse>>(`/admin/usage?${searchParams}`);
  },

  getUsageByUser: (params?: {
    start_date?: string;
    end_date?: string;
    search?: string;
    limit?: number;
    offset?: number;
  }) => {
    const searchParams = new URLSearchParams();
    if (params?.start_date) searchParams.set("start_date", params.start_date);
    if (params?.end_date) searchParams.set("end_date", params.end_date);
    if (params?.search) searchParams.set("search", params.search);
    if (params?.limit) searchParams.set("limit", String(params.limit));
    if (params?.offset) searchParams.set("offset", String(params.offset));
    return api.get<DataResponse<UserSpendResponse>>(`/usage/by-user?${searchParams}`);
  },
};

export const usageService = {
  getMySpend: (months?: number) => {
    const searchParams = new URLSearchParams();
    if (months) searchParams.set("months", String(months));
    return api.get<DataResponse<MySpendResponse>>(`/usage/my-spend?${searchParams}`);
  },
};

export const governanceService = {
  getOverview: () => api.get<DataResponse<GovernanceOverview>>("/admin/governance/overview"),
};

export const platformCostsService = {
  getOverview: (days: number = 30) =>
    api.get<DataResponse<PlatformCostsResponse>>(`/admin/platform-costs/overview?days=${days}`),
};

export const budgetService = {
  list: () => api.get<DataResponse<BudgetConfig[]>>("/admin/budgets"),

  create: (data: { scope: string; userUuid?: string; teamUuid?: string; monthlyBudgetUsd: number }) =>
    api.post<DataResponse<BudgetConfig>>("/admin/budgets", data),

  update: (id: number, data: { monthlyBudgetUsd: number }) =>
    api.put<DataResponse<BudgetConfig>>(`/admin/budgets/${id}`, data),

  delete: (id: number) => api.delete<{ message: string }>(`/admin/budgets/${id}`),
};
